/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Row, Col, Form } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import { Loader } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import { ClaimDetailsSVG } from '../../img/GlobalSVG';
import GetAdminConfiguration from '../../api/GetAdminConfig';
import APIEndpoints from '../../api/APIEndpoints';
import HttpHeader from '../../shared/httpheader';
import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import RetryAPI from '../../api/RetryAPI';
import './Registrationsetup.scss';
import RecoveryFields from './RecoveryFields';
import { axiosInstance } from '../../../api/axios';
import Header from '../../components/common/Header/Header';
import EmailResetSkeleton from './EmailResetSkeleton';
import CustomClientError from '../../errorhandling/CustomClientError';
import ToastMessage from '../common/ToastMessage';
import GenericButton from '../../../Components/GenericButton/GenericButton';

const getAdminConfigData = '';
const resetEmailData = '';
let resetOptionIdx = 0;

class EmailReset extends Component {
  constructor(props) {
    super(props);

    this.state = {
      LoadingEmailRecovery: true,
      SavingEmailRecovery: false,
      clientError: false,
      serverError: false,
      resetDisclaimer: '',
      resetAllowRecoveryUsingAltMail: false,
      isAPIFailed: false,
      isNotFound: false,
      resetOptions: {},
    };
    this.RegistrationSave = this.RegistrationSave.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  RegistrationSave = () => {
    this.setState({ SavingEmailRecovery: true });
    GetAdminConfiguration.resetDisclaimer[resetOptionIdx] =
      this.state.resetDisclaimer;
    GetAdminConfiguration.resetAllowRecoveryUsingAltMail[resetOptionIdx] =
      this.state.resetAllowRecoveryUsingAltMail === true ? 'YES' : 'NO';
    console.log('Reset Email - GetAdminConfiguration: ', GetAdminConfiguration);
    this.AddOrUpdateResetEmail();
  };

  AddOrUpdateResetEmail = async () => {
    let iIndex;

    const resetEmailRec = {
      ResetOptions: [
        {
          OID: GetAdminConfiguration.resetOid[resetOptionIdx],
          RecordType: 'Email',
          Disclaimer: GetAdminConfiguration.resetDisclaimer[resetOptionIdx],
          AllowRecoveryUsingAltMail:
            GetAdminConfiguration.resetAllowRecoveryUsingAltMail[
              resetOptionIdx
            ],
          FirstName: GetAdminConfiguration.resetFirstName[resetOptionIdx],
          LastName: GetAdminConfiguration.resetLastName[resetOptionIdx],
          DateOfBirth: GetAdminConfiguration.resetDateOfBirth[resetOptionIdx],
          SocialSecurityNumber: GetAdminConfiguration.resetSSN[resetOptionIdx],
          CertificateNumber:
            GetAdminConfiguration.resetMemberID[resetOptionIdx],
          AlternateID1: GetAdminConfiguration.resetAlternateID1[resetOptionIdx],
          AlternateID2: GetAdminConfiguration.resetAlternateID2[resetOptionIdx],
          MedicareID: GetAdminConfiguration.resetMedicareID[resetOptionIdx],
          PostalCode: GetAdminConfiguration.resetPostalCode[resetOptionIdx],
          Relationship: GetAdminConfiguration.resetRelationship[resetOptionIdx],
          Email: GetAdminConfiguration.resetAlternateEmail[resetOptionIdx],
          PhoneNumber: GetAdminConfiguration.resetPhoneNumber[resetOptionIdx],
        },
      ],
    };

    let refreshToken = '';
    let resetEmailResponse = null,
      resetEmailDataResp;
    let EncrptedResp;

    RetryAPI.setResponseReceived(false);
    RetryAPI.resetRetryCount();
    while (RetryAPI.performRetry()) {
      try {
        if (GetAdminConfiguration.resetOid[resetOptionIdx] === null) {
          EncrptedResp = await axiosInstance.post(
            APIEndpoints.addResetEmailResources(),
            resetEmailRec,
          );
        } else {
          EncrptedResp = await axiosInstance.put(
            APIEndpoints.updateResetEmailResources(),
            resetEmailRec,
          );
        }

        resetEmailResponse = EncrptedResp;

        refreshToken = resetEmailResponse.config.headers.Authorization;
        HttpHeader.refreshBearerToken(refreshToken);

        resetEmailDataResp = resetEmailResponse.data;
        if (
          resetEmailResponse.status ===
            HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
          resetEmailResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
        ) {
          RetryAPI.resetRetryCount();
          RetryAPI.setResponseReceived(true);
          console.log('Successful resetEmailResponse: ', resetEmailResponse);
        } else {
          RetryAPI.incrementRetryCount();
          RetryAPI.setResponseReceived(false);
          RetryAPI.setErrorCode(resetEmailResponse.status);
          console.log(
            'resetEmailResponse Error code:',
            resetEmailResponse.status,
          );
        }

        if (RetryAPI.getResponseReceived()) break;
      } catch (error) {
        console.log('******* 183 error', error);
        let errorMessage = '';
        //var requestAborted = '';

        if (error) {
          errorMessage = error.toString();
          //requestAborted = errorMessage.match(/aborted/i);
          RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
        }
        if (error.response) {
          RetryAPI.setErrorCode(error.response.status);
        }

        //if (axios.isCancel(error)) {
        ////////////////console.log('Previous request canceled, new request is send', error.message);
        //}

        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
      }
    }

    if (RetryAPI.retryFailed()) {
      const errorCode = RetryAPI.getErrorCode();
      HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');

      //Process Client Errors
      if (
        HttpErrorHandler.ProcessedClientErrors(
          errorCode,
          'view resetEmailResponse. ',
        )
      ) {
        toast.error(
          <ToastMessage
            type="error"
            title="Email Recovery Configuration Setup."
            subTitle="Error occurred while saving Email Recovery configuration Setup."
          />,
        );
        //Display Error Message -No claims submitted in the past six months.
        this.setState({ clientError: true });
        this.setState({ SavingEmailRecovery: false });
      } else {
        //Handle Excpetion
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to render your resetEmailResponse now.',
          )
        ) {
          this.setState({ serverError: true });
        }
      }
    } else {
      toast.success(
        <ToastMessage
          type="success"
          title="Email Recovery Configuration Setup."
          subTitle="Email Recovery Configuration Setup was saved successfully."
        />,
      );
      this.setState({ SavingEmailRecovery: false });
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getAdminConfig();
  }

  cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  getAdminConfig = async () => {
    let getAdminConfigResponse = null,
      getAdminConfigDataResp;
    let bFound = false;

    GetAdminConfiguration.setAdminConfigurationResp(null);

    RetryAPI.setResponseReceived(false);
    RetryAPI.resetRetryCount();
    while (RetryAPI.performRetry()) {
      try {
        getAdminConfigResponse = await axiosInstance.get(
          this.cacheBuster(APIEndpoints.getAdminConfigResources()),
        );
        getAdminConfigDataResp = getAdminConfigResponse.data;

        if (
          getAdminConfigResponse.status ===
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          GetAdminConfiguration.setAdminConfigurationResp(
            getAdminConfigDataResp,
          );
          RetryAPI.resetRetryCount();
          RetryAPI.setResponseReceived(true);
          console.log(
            'Successful getAdminConfigResponse: ',
            getAdminConfigResponse,
          );

          GetAdminConfiguration.ParseResetOptions();
          let getDisclaimer = '';
          for (
            let iIndex = 0;
            iIndex < GetAdminConfiguration.resetOptionsLength;
            iIndex++
          ) {
            if (GetAdminConfiguration.resetRecordType[iIndex] == 'Email') {
              resetOptionIdx = iIndex;
              getDisclaimer = GetAdminConfiguration.resetDisclaimer[iIndex];
              this.setState({
                resetDisclaimer: GetAdminConfiguration.resetDisclaimer[iIndex],
                resetAllowRecoveryUsingAltMail:
                  GetAdminConfiguration.resetAllowRecoveryUsingAltMail[
                    iIndex
                  ] == 'YES'
                    ? true
                    : false,
              });
              bFound = true;
            }
          }
          if (!bFound) resetOptionIdx = 1;

          const options =
            getAdminConfigDataResp &&
            getAdminConfigDataResp?.Response?.ResetOptions?.filter(
              (item) => item.RecordType === 'Email',
            );

          const arr = [];
          options.map((option) => {
            if (option.Disclaimer === getDisclaimer) {
              arr.push(option);
            }
          });

          arr.length &&
            this.setState({
              resetOptions: arr[0],
            });
        } else {
          RetryAPI.incrementRetryCount();
          RetryAPI.setResponseReceived(false);
          RetryAPI.setErrorCode(getAdminConfigResponse.status);
        }

        if (RetryAPI.getResponseReceived()) break;
      } catch (error) {
        let errorMessage = '';
        this.setState({
          isAPIFailed: true,
        });
        if (error.toString().includes('404')) {
          this.setState({
            isNotFound: true,
          });
        }

        if (error) {
          errorMessage = error.toString();
          //requestAborted = errorMessage.match(/aborted/i);
          RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
        }
        if (error.response) {
          RetryAPI.setErrorCode(error.response.status);
        }

        //if (axios.isCancel(error)) {
        ////////////////console.log('Previous request canceled, new request is send', error.message);
        //}

        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
      }
    }

    if (RetryAPI.retryFailed()) {
      const errorCode = RetryAPI.getErrorCode();
      HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');

      //Process Client Errors
      if (
        HttpErrorHandler.ProcessedClientErrors(
          errorCode,
          'view getAdminConfigResponse. ',
        )
      ) {
        //Display Error Message -No claims submitted in the past six months.
        this.setState({ clientError: true });
        this.setState({ LoadingEmailRecovery: false });
      } else {
        //Handle Excpetion
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to render your getAdminConfigResponse now.',
          )
        ) {
          this.setState({ serverError: true });
        }
      }
      return;
    } else {
      this.setState({ LoadingEmailRecovery: false });
    }
  };

  handleChange = (event) => {
    console.log(event.target.name);
    console.log(event.target.checked);
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleInputChange(event) {
    console.log('Name: ', event.target.name);
    console.log('Value: ', event.target.value);
    this.setState({
      ...this.state,
      [event.target.name]: event.target.value,
    });
  }

  render() {
    const {
      backtoDashboard,
      serverError,
      clientError,
      LoadingEmailRecovery,
      SavingEmailRecovery,
      resetDisclaimer,
      resetAllowRecoveryUsingAltMail,
      isAPIFailed,
      isNotFound,
    } = this.state;

    console.log('render Called');

    if (serverError)
      return <Navigate to="/admin/server-error" push={true}></Navigate>;

    if (backtoDashboard) {
      return <Navigate to="/admin/dashboard" push={true}></Navigate>;
    }

    const { t } = this.props;
    return (
      <>
        <Container fluid className="claims-details email-reset-form">
          <div className="toastify">
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>

          {!LoadingEmailRecovery && isAPIFailed ? (
            <Container className="px-0">
              {isNotFound ? (
                <CustomClientError
                  ErrorHeading="No data found!"
                  ErrorMessage="We are unable to render your response now. "
                />
              ) : (
                <CustomClientError
                  ErrorHeading="Something went wrong with request!"
                  ErrorMessage="Please try again."
                />
              )}
            </Container>
          ) : LoadingEmailRecovery ? (
            <EmailResetSkeleton />
          ) : (
            <div>
              <Header
                linkTo={'/admin/admin-dashboard'}
                header={t('admin.pages.email_reset.module')}
              />

              <Row className="Payment-details">
                <Col className="padding-0">
                  <h3>Disclaimer</h3>
                </Col>
                <Col>
                  <label
                    className="sr-only"
                    htmlFor="outlined-multiline-static"
                  >
                    resetDisclaimer
                  </label>
                  <TextField
                    style={{ borderColor: 'white' }}
                    id="outlined-multiline-static"
                    label=""
                    multiline
                    rows={4}
                    defaultValue={resetDisclaimer}
                    fullWidth
                    variant="outlined"
                    name="resetDisclaimer"
                    onChange={this.handleInputChange}
                  />
                </Col>
              </Row>
              <Row className="Payment-details">
                <Col className="padding-0">
                  <h3>Information to Validate</h3>
                  <p>
                    Define Additional Fields that will identify the Members in
                    the portal. Maximum 6 fields can be selected.
                  </p>
                  <p>
                    Recommended additional fields to find a unique member record
                    - First Name, Last Name, DOB and Postal code along with
                    Member ID or SSN. Other additional fields should be selected
                    for more security.
                  </p>
                </Col>
                <Col className="setup-form">
                  <RecoveryFields
                    iIndex={resetOptionIdx}
                    fields={this.state.resetOptions}
                  />
                </Col>
              </Row>
              <Row className="Payment-details password-policy">
                <Col className="padding-0">
                  <h3>Use Alternate Email</h3>
                  <p>
                    Select whether to send the details to Alternate Email ID
                  </p>
                  {/*<Form.Group id="formGridCheckbox1">
                  <Form.Check type="checkbox" label="Enable One Time Password"/>
            </Form.Group>  */}
                </Col>
                <Col>
                  <Form.Group id="formGridCheckbox1" className="d-flex">
                    <Form.Label className="sr-only" for="Alternate1">
                      Alternate
                    </Form.Label>
                    <Form.Check
                      checked={resetAllowRecoveryUsingAltMail}
                      type="checkbox"
                      label="Allow to recover using Alternate Email"
                      id="Alternate"
                      onChange={this.handleChange}
                      name="resetAllowRecoveryUsingAltMail"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="Payment-details password-policy border-bottom-0">
                <Col className="float-right text-right">
                  {/*<Button variant="light" className='rec-settings'>Recommended Settings</Button> */}
                  <GenericButton
                    disable={SavingEmailRecovery}
                    postLabel="SAVE"
                    onClick={this.RegistrationSave}
                  >
                    SAVE
                  </GenericButton>
                </Col>
              </Row>
            </div>
          )}
          {SavingEmailRecovery && (
            <div className="custom-loader mt-0 d-flex justify-content-end sr-only">
              <div className="loader-icon position-relative mr-4">
                <Loader
                  className="text-dark font-weight-bold loader-color marginTop-Login-loader"
                  size="small"
                  active
                />
              </div>
              <div className="text-dark font-weight-bold" role="alert">
                Saving Email Recovery Configuration Setup
                <span aria-hidden={true}>...</span>
              </div>
            </div>
          )}
        </Container>
      </>
    );
  }
}
export default withTranslation()(EmailReset);
